import React, { useEffect, useState } from "react";
import TagPill from "../AddEditTagModal/TagPill/TagPill";

// Style
import "./TagsInput.scss";

const TagsInput = ({
  isDocumentView,
  listTags,
  areAllTagsValid,
  setAreAllTagsValid,
  setTagList,
  tagList,
  mode,
  selectedTag,
  singleTagString,
  setSingleTagString,
}) => {
  const [tagString, setTagString] = useState("");

  useEffect(() => {
    const list = tagString
      .split(",")
      .filter((tag) => tag.trim() !== "")
      .map((tag) => tag.trim());
    setTagList(list);
    setAreAllTagsValid(true);
  }, [tagString, setAreAllTagsValid, setTagList]);

  const handleTagsStringChange = (e) => {
    setTagString(e.target.value);
  };

  const handleEditTagStringChange = (e) => {
    setAreAllTagsValid(true);
    setSingleTagString(e.target.value);
    isValidTag(e.target.value.trim());
  };

  const removeTagFromList = (index) => {
    const newTagList = [...tagList];
    newTagList.splice(index, 1);
    setTagString(newTagList.join(", "));
  };

  const isValidTag = (tag) => {
    // If update only check if there is no other tag named after the tag
    let isValid = true;
    if (selectedTag) {
      if (tag.toLowerCase() === selectedTag.name.toLowerCase()) {
        isValid = true;
      } else {
        isValid = listTags.filter((listTag) => listTag.name.toLowerCase() === tag.toLowerCase()).length === 0;
      }
    } else {
      // Check if older list has the tag already
      // Check if currect tag list has duplicate values
      isValid =
        listTags.filter((listTag) => listTag.name.toLowerCase() === tag.toLowerCase()).length === 0 &&
        tagList.filter((tempTag) => tempTag.toLowerCase() === tag.toLowerCase()).length <= 1;
    }
    if (!isValid) {
      setAreAllTagsValid(false);
    }
    return isValid;
  };

  return (
    <div className="tag-input-container">
      {isDocumentView || selectedTag ? (
        <div className="form-groups mb-8">
          <div className="form-group">
            <label>
              <strong>Tag Name</strong>
            </label>
            <input
              type="text"
              value={singleTagString}
              onChange={handleEditTagStringChange}
              placeholder="Enter tag name"
              className={` ${!areAllTagsValid ? "error-input" : ""}`}
            />
          </div>
        </div>
      ) : (
        <>
          <div className="form-groups">
            <div className="form-group">
              <label>
                <strong>Tag Name(s)</strong>
              </label>
              <input
                type="text"
                value={tagString}
                onChange={handleTagsStringChange}
                placeholder="Enter tag name(s) with comma separation"
                className={` ${!areAllTagsValid ? "error-input" : ""}`}
              />
            </div>
          </div>
          <div className="tag-pills">
            {tagList.map((tag, index) => (
              <TagPill {...{ tag, index, removeTagFromList, isValidTag, key: Math.random() }} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TagsInput;
